module.exports = __webpack_public_path__ + "static/media/sub_ourservices_tutoringprogram.cd5003dc.jpg";